import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  validateAndSubmitSearchForm,
  expandAccordionsByErrorPaths,
} from '@frontend/pricing-search';
import { PATH_SEARCH_RESULTS } from '../../../../route/constants';
import { searchFormActions } from '../../../../store/searchForm';
import { FooterButtons } from '../../../components/FooterButtons';
import { setLoanInfo } from '../../../components/Form/utils/common';

export const FooterForm = ({
  schema,
  schemaForm,
  accordionFieldMap,
  setActiveAccordions,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSearchAction = async () => {
    const result = await validateAndSubmitSearchForm({
      schema,
      schemaForm,
      preview: false,
    });

    if (result.valid) {
      dispatch(setLoanInfo(result.formData) as any);
      dispatch(searchFormActions.setBannerIsOpen(false));
      navigate(PATH_SEARCH_RESULTS);
    } else {
      dispatch(searchFormActions.setBannerIsOpen(true));

      if (result.errorPaths?.length) {
        const toOpen = expandAccordionsByErrorPaths(
          accordionFieldMap,
          result.errorPaths,
        );
        setActiveAccordions((prev) => ({ ...prev, ...toOpen }));
      }
    }
  };

  return (
    <FooterButtons
      buttons={[
        {
          type: 'primary',
          text: 'Search',
          onClick: handleSearchAction,
          'data-testid': 'footer-button-search',
        },
      ]}
    />
  );
};
